<div class="hidden lg:flex items-center justify-end gap-2">
  <app-link (click)="tourService.start('lookup')" title="Show tour" class="hidden lg:block" id="results-tour">
    <app-icons icon="info-circle" width="20"></app-icons>
  </app-link>

  @if (settingsVisible()) {
    <app-link href="settings" [disabled]="settingsDisabled()" [title]="access.getTitle('edit_settings', 'Open settings')" id="lookup-settings-cog">
      <app-icons icon="gear" width="20"></app-icons>
    </app-link>
  }
</div>
